const INITIAL_STATE = {
  centreName: '',
  employmentStatus: 'employed',
  applicantName: '',
  testerName: '',
  applicantPhoneNumber: '',
  applicantEmail: '',
  declaration: false,
  signedLogbook: false,
  terms: false,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case 'GET_LEGAL_DATA':
      return {
        ...state,
        ...payload,
      };
    case 'SUBMIT_SIGNATURE_DATA':
      return {
        ...state,
        ...payload,
      };
    case 'SIGNATURE_INITIAL_STATE':
      return {
        ...state,
      };
    default:
  }
  return state;
};
